import * as orders from './list'

import { Order } from '@/types/operations/order'

export const allOrders: Order[] = Object.values(orders).sort(
    (previous, current) => current.id - previous.id,
)
